import React from 'react';
import '../styles/pages.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-page container" style={{ marginTop: '2rem', marginBottom: '4rem' }}>
      <section className="page-hero">
        <div className="page-hero-content">
          <h1>Privacy Policy</h1>
          <p className="hero-subtitle">
            How we protect your data and integrate third-party advertising services on the Vedic Surgery platform.
          </p>
        </div>
      </section>

      <div className="content-card" style={{ marginTop: '2rem' }}>
        <div className="intro-content">
          <p className="lead">
            Welcome to the Vedic Surgery Project. We are committed to protecting your personal data and ensuring your experience on our platform is safe, transparent, and educational.
          </p>

          <hr style={{ border: 'none', borderBottom: '1px solid var(--border-color)', margin: '2rem 0' }} />

          <h2>1. Information We Collect</h2>
          <p>
            We collect personal information that you voluntarily provide to us when you register on our platform, update your profile, subscribe to our newsletter, or submit queries via our Contact page. This information may include:
          </p>
          <ul style={{ paddingLeft: '1.5rem', marginBottom: '1.5rem', listStyleType: 'disc' }}>
            <li style={{ marginBottom: '0.5rem', color: 'var(--text-secondary)' }}>Name and Email Address</li>
            <li style={{ marginBottom: '0.5rem', color: 'var(--text-secondary)' }}>Organization or Institution</li>
            <li style={{ marginBottom: '0.5rem', color: 'var(--text-secondary)' }}>Profile image uploads (limited to a maximum of 1 MB)</li>
          </ul>

          <h2>2. How We Use Your Information</h2>
          <p>
            Your information is used to personalize your learning experience, process Prakriti constitution evaluations, deliver care recommendations, send newsletter updates, and maintain security on our platform.
          </p>

          <h2>3. Cookies and Advertising (Google AdSense)</h2>
          <p>
            We display advertisements served by third-party vendors, including Google, to help support and run the Vedic Surgery educational platform. Please review the following disclosures regarding our advertising integration:
          </p>
          <ul style={{ paddingLeft: '1.5rem', marginBottom: '1.5rem', listStyleType: 'disc' }}>
            <li style={{ marginBottom: '0.8rem', color: 'var(--text-secondary)' }}>
              <strong>Third-party cookies:</strong> Third-party vendors, including Google, use cookies to serve ads based on your prior visits to our website or other websites on the Internet.
            </li>
            <li style={{ marginBottom: '0.8rem', color: 'var(--text-secondary)' }}>
              <strong>Personalized advertising:</strong> Google's use of advertising cookies enables it and its partners to serve ads to you based on your visits to our site and/or other sites on the Internet.
            </li>
            <li style={{ marginBottom: '0.8rem', color: 'var(--text-secondary)' }}>
              <strong>Opting Out:</strong> You may opt out of personalized advertising by visiting Google's <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--primary-color)', textDecoration: 'underline' }}>Ads Settings</a>. Alternatively, you can opt out of a third-party vendor's use of cookies for personalized advertising by visiting the <a href="https://www.aboutads.info" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--primary-color)', textDecoration: 'underline' }}>AboutAds.info</a> portal.
            </li>
          </ul>


          <h2>4. Data Storage and Soft Deletion</h2>
          <p>
            Our backend services maintain strict security controls. Personal profiles and records remain stored securely in our databases. In compliance with our global workspace standards, any deletion requests trigger a soft delete (updating our database's active status from active to inactive) rather than a permanent hard purge, allowing data recovery while respecting your privacy configurations.
          </p>

          <h2>5. Contact Us</h2>
          <p>
            If you have questions or concerns regarding this Privacy Policy, please contact our support team at <strong style={{ color: 'var(--primary-color)' }}>vedicsurgery@gmail.com</strong>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
